import { useMemo } from 'react';
import { getLocale } from '@edx/frontend-platform/i18n';

import { ALLOWED_SITE_LANGUAGES, DEFAULT_LANGUAGE } from '../utils';
import type { AllowedCourseItem, LearningPathConfigResponse } from '../types';

/**
 * Returns the courses allowed for the user's current locale, falling back to
 * the default language when the active locale isn't one we serve content for.
 */
export const useAllowedCourses = (
  config: LearningPathConfigResponse | null,
): AllowedCourseItem[] => {
  const rawLocale = getLocale();
  const locale = ALLOWED_SITE_LANGUAGES.includes(rawLocale) ? rawLocale : DEFAULT_LANGUAGE;
  return useMemo(
    () => config?.[locale]?.allowed_courses ?? [],
    [config, locale],
  );
};
